import { useAnalytics } from 'app/context/Analytics';
import { PosthogEventName } from 'app/copied/constants/PosthogEventName';
import { SuggestedEntry } from 'app/copied/models/ChatModules';
import { checkIsExternalLinkWithImage } from 'app/services/search';

export default function useSuggestedArticleTracking() {
  const { captureEventWithTopicSourceAndActiveScreen } = useAnalytics();

  const captureSuggestedTopicAppearance = (
    suggestedTopic?: SuggestedEntry | null,
    currentTopic?: SuggestedEntry | null,
    suggestedTopicSource: 'widget' | 'nonWidget' = 'widget'
  ) => {
    captureEventWithTopicSourceAndActiveScreen(PosthogEventName.SuggestedTopicAppearance, {
      suggestedTopicTitle: suggestedTopic?.title,
      suggestedUrl: suggestedTopic ? getTopicUrl(suggestedTopic) : undefined,
      suggestedTopicType: suggestedTopic ? getSuggestedTopicType(suggestedTopic) : undefined,
      suggestedTopicSource: suggestedTopicSource,
      nbaDesignVersion: '', //may25
      topicType: currentTopic ? getSuggestedTopicType(currentTopic) : undefined,
      topicTitle: currentTopic?.title,
      url: currentTopic ? getTopicUrl(currentTopic) : undefined,
    });
  };

  const captureSuggestedTopicClicked = (
    suggestedTopic?: SuggestedEntry | null,
    currentTopic?: SuggestedEntry | null,
    suggestedTopicSource: 'widget' | 'nonWidget' = 'widget',
    timeSinceNbaLoad = 0, //in milliseconds
    nbaMinimized = false,
    nbaDesignVersion = ''
  ) => {
    captureEventWithTopicSourceAndActiveScreen(PosthogEventName.SuggestedTopicClicked, {
      suggestedTopicType: suggestedTopic ? getSuggestedTopicType(suggestedTopic) : undefined,
      suggestedTopicTitle: suggestedTopic?.title,
      suggestedUrl: suggestedTopic ? getTopicUrl(suggestedTopic) : undefined,
      suggestedTopicSource: suggestedTopicSource,
      timeSinceNbaLoad: timeSinceNbaLoad,
      nbaDesignVersion, //may25
      nbaMinimized: nbaMinimized,
      topicType: currentTopic ? getSuggestedTopicType(currentTopic) : undefined,
      topicTitle: currentTopic?.title,
      url: currentTopic ? getTopicUrl(currentTopic) : undefined,
    });
  };

  const captureSuggestedTopicClosed = (
    suggestedTopic?: SuggestedEntry | null,
    currentTopic?: SuggestedEntry | null,
    suggestedTopicSource: 'widget' | 'nonWidget' = 'widget'
  ) => {
    captureEventWithTopicSourceAndActiveScreen(PosthogEventName.SuggestedTopicClosed, {
      suggestedTopicType: suggestedTopic ? getSuggestedTopicType(suggestedTopic) : undefined,
      suggestedTopicTitle: suggestedTopic?.title,
      suggestedUrl: suggestedTopic ? getTopicUrl(suggestedTopic) : undefined,
      suggestedTopicSource: suggestedTopicSource,
      topicType: currentTopic ? getSuggestedTopicType(currentTopic) : undefined,
      topicTitle: currentTopic?.title,
      url: currentTopic ? getTopicUrl(currentTopic) : undefined,
    });
  };

  return {
    captureSuggestedTopicAppearance,
    captureSuggestedTopicClicked,
    captureSuggestedTopicClosed,
  };
}

function getTopicUrl(topic: SuggestedEntry) {
  return topic.external_link || topic.resource_link || '';
}

export function getSuggestedTopicType(topic: SuggestedEntry): 'Content' | 'ExternalLink' | 'ExternalThumbnailLink' {
  if (checkIsExternalLinkWithImage(topic)) {
    return 'ExternalThumbnailLink';
  } else if (topic.external_link || topic.resource_link) {
    return 'ExternalLink';
  }
  return 'Content';
}
